<script setup>
import { storeToRefs } from 'pinia';
import { HrUploadProgressIndicator } from 'src/design-system';
import { firebaseUploader } from 'src/store/firebaseUploader';
import { computed } from 'vue';

defineOptions({ name: 'UploadProgress' });

defineProps({
  color: {
    type: String,
    default: 'white',
  },
  showAlways: {
    type: Boolean,
    default: false,
  },
});

const { uploadQueue } = storeToRefs(firebaseUploader());

const overallProgress = computed(() => {
  if (uploadQueue.value.length > 0) {
    let totalBytes = 0;
    let bytesTransferred = 0;
    uploadQueue.value.forEach((f) => {
      bytesTransferred += f.bytesTransferred;
      totalBytes += f.totalBytes;
    });
    if (totalBytes > 0) {
      return (bytesTransferred / totalBytes) * 100;
    }
  }
  return 100;
});
</script>

<template>
  <div
    v-if="uploadQueue.length > 0 || showAlways"
  >
    <hr-upload-progress-indicator
      :value="overallProgress"
      :legacy-props="{ color }"
    />
  </div>
</template>
